import {
  NETWORK_ERROR,
  NETWORK_START,
  NETWORK_STOP,
  LOADING_START,
  LOADING_STOP,
} from "../constants";

const initialState = {
  loading: false,
  networkRequests: 0,
  lastError: null,
};

export default function networkReducer(state = initialState, action) {
  switch (action.type) {
    case NETWORK_ERROR:
      return { ...state, lastError: action.error };

    case NETWORK_START:
      return { ...state, networkRequests: state.networkRequests + 1 };

    case NETWORK_STOP:
      return { ...state, networkRequests: state.networkRequests - 1 };

    case LOADING_START:
      return { ...state, loading: true };

    case LOADING_STOP:
      return { ...state, loading: false };

    default:
      return state;
  }
}
